package com.example.mystybag.appCore.logic

import com.example.mystybag.appCore.model.CitySelectionBottomSheetUIState
import com.example.mystybag.communication.common.CommonCommands
import com.example.mystybag.communication.utils.onResponse
import com.example.mystybag.common.logic.BSNavigatorCitySelection
import com.example.mystybag.core.logic.base.AppContext
import com.example.mystybag.core.logic.base.ChildViewModel
import com.example.mystybag.sharedmodels.project.responseModels.CityResponseModel

class CitySelectionBottomSheetViewModel(
    context: AppContext,
    private val config: BSNavigatorCitySelection
) : ChildViewModel<CitySelectionBottomSheetUIState>(
    context,
    CitySelectionBottomSheetUIState(
        selectedCity = null,
        searchText = config.initialCityName
    )
) {

    override fun onCreate() {
        loadCities()
    }

    private fun loadCities() {
        updateState { it.copy(isLoading = true) }
        commandBlock {
            CommonCommands.sendGetCities()
                .onResponse(
                    success = { response ->
                        launchOnMain {
                            val list = response.citiesList
                            val selected = list.find { it.cityName.equals(config.initialCityName, ignoreCase = true) }
                            updateState { state ->
                                state.copy(
                                    cities = list,
                                    isLoading = false,
                                    selectedCity = selected ?: state.selectedCity
                                )
                            }
                        }
                    },
                    baseError = { response ->
                        launchOnMain {
                            updateState { it.copy(isLoading = false) }
                            showSnackbar(com.example.mystybag.communication.utils.Response.getErrorMessage(response.status, response.apiEndPoint, response.statusMessage))
                        }
                    }
                )
        }
    }

    override fun onSearchTextChanged(search: String) {
        super.onSearchTextChanged(search)
        updateState { it.copy(searchText = search) }
    }

    fun onCitySelected(city: CityResponseModel) {
        updateState { it.copy(selectedCity = city) }
    }

    fun onSaveClicked() {
        val city = uiState.value.selectedCity
        if (city != null) {
            config.onCitySelected(city.id, city.cityName)
            closeBottomSheet()
        }
    }
}
